import { AspectRatio, Box, Flex, Text } from '@chakra-ui/react'
import Image from 'next/image'
import { MainContainer } from './index'
import { Link as ScrollLink } from 'react-scroll'

const Body = () => {
  return (
    <Box
      data-aos="fade-up"
      w="100%"
      position="relative"
      minH={{
        base: 'unset',
        xl: '1456px'
      }}
      pb={{
        base: '100px',
        md: '180px',
        xl: '0px'
      }}
    >
      <MainContainer
        mt={{
          base: '96px',
          xl: '96px'
        }}
        data-aos="fade-up"
      >
        <Text
          textStyle="supplementBodyTitle"
          textTransform="uppercase"
          textAlign={{
            base: 'center'
          }}
          w="100%"
          zIndex={100}
          fontWeight={700}
        >
          ALL FOR YOUR HEALTH
        </Text>
        <Text
          textStyle="supplementBodySubTitle"
          textAlign={{
            base: 'center'
          }}
          w="100%"
          zIndex={100}
          color={'#404040'}
          mt={1}
          mb="55px"
        >
          Click on the product to know more!
        </Text>
        <Flex justifyContent="center">
          <Box
            w={{
              base: '100%',
              sm: '600px',
              md: '800px',
              xl: '980px'
            }}
            position="relative"
          >
            <AspectRatio ratio={980 / 1023} className="w-full">
              <>
                <Image
                  src={
                    'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-body-1733722418401.png'
                  }
                  alt="health care"
                  fill
                />
              </>
            </AspectRatio>

            {/* Brain Health */}
            <Box
              position="absolute"
              top="5.2%"
              left="17.2%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="brain-memory"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/* Hair Health */}
            <Box
              position="absolute"
              top="6.9%"
              left="70.0%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="hair-regain"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/*  Vascular Health */}
            <Box
              position="absolute"
              top="27.3%"
              left="10.4%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="vascula-health"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/* Stomach Health */}
            <Box
              position="absolute"
              top="30.1%"
              left="79.2%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="anti-dampness"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>
            {/* Joint Health */}
            <Box
              position="absolute"
              top="51.3%"
              left="10.5%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="uric-acid-control"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/* Vitality */}
            <Box
              position="absolute"
              top="54.5%"
              left="77%"
              width="13.5%"
              height="20%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="cordyceps-sinensis"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/* Detocification */}
            <Box
              position="absolute"
              top="73.5%"
              left="24.6%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="bitter-melon"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>

            {/* Overall Health */}
            <Box
              position="absolute"
              top="75.1%"
              left="56.2%"
              width="13.5%"
              height="19.5%"
              cursor="pointer"
            >
              {/* <Scoll */}
              <ScrollLink
                to="wild-ganoderma"
                smooth={true}
                duration={500}
                offset={-50} // Adjusted for header height
              >
                <Box h={'100%'} w={'100%'}></Box>
              </ScrollLink>
            </Box>
          </Box>
        </Flex>

        <Box position={'absolute'} bottom={0} left={0} right={0}>
          <AspectRatio ratio={2740 / 158} w={'100%'} position="relative">
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-body-bot-1730953433163.png"
              alt="bg bot item"
              fill
              className="object-cover"
            />
          </AspectRatio>
        </Box>
      </MainContainer>
    </Box>
  )
}

export default Body
